// Reusable sectioned panel for detail/edit screens.
// Header with title + optional icon + optional right-side accessory (link, count).
//
// 14 Sept 2026 (sweep item 70): the local Badge, Num, KeyValue and Dim copies
// are GONE — the party page, the deal panel, the Statement, Treasury, KYT and
// GroupingPanel use the shared Pill (components/Pill.tsx), the shared KeyValue
// (components/KeyValue.tsx) and the one negative token. This file is the
// panel and nothing else.

import type { ReactNode } from 'react';

export function Section({
  title,
  icon,
  accessory,
  children,
}: {
  title: string;
  icon?: ReactNode;
  accessory?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="card">
      <header className="flex items-center justify-between mb-2">
        <h2 className="font-semibold text-body flex items-center gap-1.5">
          {icon && <span className="opacity-70">{icon}</span>}
          {title}
        </h2>
        {accessory && <div className="text-meta">{accessory}</div>}
      </header>
      <div className="space-y-1">{children}</div>
    </section>
  );
}
